import ProductGrid from '../ProductGrid/ProductGrid'

const PayloadGrid = ({ payload_id }) => {
  return (
    <ProductGrid
      searchUri={'/API_FRONT/payload/items/get-list/'}
      payload_id={payload_id}
    />
  )
}
export default PayloadGrid
